export default {
  statusPending: 'Pending',
  statusApproved: 'Approved',
  statusDeclined: 'Declined',
  statusCancelled: 'Cancelled',
  range: '{from} to {to}',
  dayOne: '{count} day',
  dayOther: '{count} days',
  pendingSuffix: ', {days} pending',
  available: '{days} available{pending}',
  takenThisYear: '{days} taken this year{pending}',
  pendingBalance: 'Balance: {summary} (including this request)',
  fromTheApp: 'From the app',
  note: 'Note: {note}',
  approved: 'Leave approved.',
  declined: 'Leave declined.',
  cancelled: 'Leave cancelled.',
  approve: 'Approve',
  decline: 'Decline',
  added: 'Leave added.',
  addRequest: 'Add leave request',
  addDescription: "Record leave on the employee's behalf.",
  employee: 'Employee',
  selectEmployee: 'Select an employee',
  category: 'Leave category',
  selectCategory: 'Select a category',
  from: 'From',
  to: 'To',
  commentOptional: 'Comment (optional)',
  approveNow: 'Approve straight away',
  addLeave: 'Add leave',
  perYear: ' · {days} a year',
  inactive: ' (inactive)',
  notTracked: 'Not tracked',
  daysAYear: 'days a year',
  categoryUpdated: '{name} updated.',
  entitlements: 'Entitlements',
  entitlementsMeta: 'Working days earned a year, pro rata. Blank means not tracked.',
  leave: 'Leave',
  requestOne: '{count} request',
  requestOther: '{count} requests',
  emptyTitle: 'No leave requests',
  emptyMessage: 'Approved leave stops absence reminders on those days.',
  pageDescription: 'Review and record time off, including requests employees make from the app. Approved leave stops absence reminders and is flagged when rostering.',
  requests: 'Requests',
  filterByStatus: 'Filter by status',
  nothingHere: 'Nothing here',
  noPending: 'No leave is waiting for a decision.',
  noMatch: 'No leave matches that filter.',

  // Certificates (doctor's notes) attached to a request
  certificateOne: '{count} certificate',
  certificateOther: '{count} certificates',
  attachCertificate: 'Attach certificate',
  attaching: 'Attaching…',
  certificateAttached: 'Certificate attached.',
  certificatesEmpty: 'No certificates attached.',
  certificateFromApp: 'Uploaded from the app',
  downloadCertificate: 'Download {name}',
  deleteCertificate: 'Delete {name}',
  deleteCertificateTitle: 'Delete this certificate?',
  deleteCertificateMessage: '{name} will be permanently removed.',
  certificateDeleted: 'Certificate deleted.',

  // Sick leave
  sickCategory: 'Sick leave',
  sickCategoryHelp: 'Categories marked as sick leave use the sick leave notifications below, and employees can report them in one tap from the app.',
  sickRoutingTitle: 'Sick leave notifications',
  sickRoutingDescription: 'Who is emailed when someone requests sick leave.',
  routingStandard: 'Standard',
  routingStandardBody: "Their manager, otherwise their site's managers, otherwise all admins.",
  routingCustom: 'Choose who is told',
  routingCustomBody: 'Tick the groups, and add any specific people, who should be emailed.',
  routeManager: 'Their manager',
  routeSiteManagers: "Managers of the site they're working",
  routeJobContacts: 'The contact set on each job',
  routeAdmins: 'All admins',
  routePeople: 'Specific people',
  routePeopleHint: 'Up to {max} employees with an email address. They are told about every sick leave request.',
  routeFallback: 'If none of these apply, it falls back to the standard routing so nobody is missed.',
  routeJobsNote: 'Individual jobs can add contacts, or replace this routing, under "Sick leave contacts" in the job dialog.',
  sickRoutingSaved: 'Sick leave notifications saved.',

  // Contractors
  noEntitlement: 'No entitlement',
  noEntitlementNote: "Contractor: a notice that they can't work, not paid leave.",

  // Site closed for weather
  weatherClosure: 'Site closed for weather',
  weatherDescription: 'Records approved inclement weather leave for everyone with a shift or a published job at the site on those days. The shifts and jobs themselves are not cancelled.',
  weatherSite: 'Site',
  weatherSelectSite: 'Select a site',
  weatherChecking: 'Checking who is rostered…',
  weatherRangeTooLong: 'A closure can cover up to 14 days.',
  weatherToBeforeFrom: "The end date can't be before the start date.",
  weatherPreviewOne: '{count} person rostered at {site} will be recorded as on inclement weather leave.',
  weatherPreviewOther: '{count} people rostered at {site} will be recorded as on inclement weather leave.',
  weatherNobody: 'Nobody is rostered at {site} on those days.',
  weatherAllOnLeave: 'Everyone rostered at {site} on those days is already on leave.',
  weatherAlreadyOne: '{count} person is already on leave and will be left as they are: {names}.',
  weatherAlreadyOther: '{count} people are already on leave and will be left as they are: {names}.',
  weatherDayOne: '{date}: {count} person',
  weatherDayOther: '{date}: {count} people',
  weatherConfirmOne: 'Record for {count} person',
  weatherConfirmOther: 'Record for {count} people',
  weatherRecording: 'Recording…',
  weatherRecordedOne: 'Recorded inclement weather for {count} person.',
  weatherRecordedOther: 'Recorded inclement weather for {count} people.',
}
